import React from 'react';
import { Label } from 'flowbite-react';
import Select from 'react-select';
import { CurrentWorkingStatus, PreInterviewsFormData } from 'types';
import moment from 'moment';
import { gradYearOptions } from 'shared-utils';
import { pifChangableFieldsConfig } from 'src/utils/pifConfig';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	formData: Partial<PreInterviewsFormData>;
	setFormData: (arg: Partial<PreInterviewsFormData>) => void;
}

const FormIfStudying = ({ formData, setFormData }: Props) => {
	const futureGradYearOptions = gradYearOptions.filter(op => Number(op.value) >= moment().year());
	const { user } = useUserContext();
	return (
		<div className="mt-2 font-inter">
			<Label className="">
				Graduation Year <span className="text-red-600">*</span>
			</Label>
			<Select
				isDisabled={pifChangableFieldsConfig.graduationYear === false && user?.profile.gradYear ? true : false}
				menuPlacement={'auto'}
				className="single-value-select-tag !max-w-[500px]"
				classNamePrefix="my-select-plans"
				instanceId="studyingGradYear"
				closeMenuOnSelect
				options={futureGradYearOptions}
				value={futureGradYearOptions?.find(item => Number(item.value) === formData.graduationYear)}
				onChange={value => {
					setFormData({
						...formData,
						currentWorkingStatus: CurrentWorkingStatus.Studying,
						graduationYear: Number(value?.value),
					});
				}}
			/>
		</div>
	);
};

export default FormIfStudying;
